import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 bg-white border-b ${
        scrolled
          ? "border-brand-line shadow-[0_4px_20px_-8px_rgba(44,76,59,0.12)]"
          : "border-transparent"
      }`}
    >
      <div className="container-prose flex items-center justify-between py-4 md:py-5">
        <Link
          to="/"
          data-testid="header-logo"
          aria-label="Club Amistad — Inicio"
          className="flex items-center group"
        >
          <img
            src="/club-amistad-logo.png"
            alt="Club Amistad"
            className={`transition-all duration-300 ${
              scrolled ? "h-11 md:h-12" : "h-12 md:h-14"
            } w-auto group-hover:scale-[1.03]`}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="Principal">
          <NavLink
            to="/"
            data-testid="nav-home"
            end
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-brand-primary" : "text-brand-ink/70 hover:text-brand-primary"
              }`
            }
          >
            Inicio
          </NavLink>
          <a
            href="/#viajes"
            data-testid="nav-trips"
            className="text-sm font-medium text-brand-ink/70 hover:text-brand-primary transition-colors"
          >
            Viajes
          </a>
          <a
            href="/#nosotros"
            data-testid="nav-about"
            className="text-sm font-medium text-brand-ink/70 hover:text-brand-primary transition-colors"
          >
            Nosotros
          </a>
          <NavLink
            to="/blog"
            data-testid="nav-blog"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-brand-primary" : "text-brand-ink/70 hover:text-brand-primary"
              }`
            }
          >
            Blog
          </NavLink>
          <a
            href="/#contacto"
            data-testid="nav-contact"
            className="btn-primary !py-2.5 !px-5 text-sm"
          >
            Háblanos
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-line bg-white text-brand-primary"
          aria-label="Menú"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-brand-line bg-white/95 backdrop-blur-xl"
        >
          <div className="container-prose flex flex-col gap-3 py-5">
            <Link to="/" className="py-2 text-brand-ink/80 font-medium" data-testid="mobile-nav-home">
              Inicio
            </Link>
            <a href="/#viajes" className="py-2 text-brand-ink/80 font-medium" data-testid="mobile-nav-trips">
              Viajes
            </a>
            <a href="/#nosotros" className="py-2 text-brand-ink/80 font-medium" data-testid="mobile-nav-about">
              Nosotros
            </a>
            <Link to="/blog" className="py-2 text-brand-ink/80 font-medium" data-testid="mobile-nav-blog">
              Blog
            </Link>
            <a href="/#contacto" className="btn-primary justify-center" data-testid="mobile-nav-contact">
              Háblanos
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
